import React from "react";
import {useLoadNotificationGroup} from "./useLoadNotificationGroup";

export function NotificationGroupName({groupID}: {groupID: string}) {
    const {data: group, isLoading} = useLoadNotificationGroup(groupID);
    if (isLoading) return <span className="inline-block h-3 w-24 rounded-full bg-light-light-grey animate-pulse" />;
    if (!group) return <span className="text-light-grey">—</span>;
    return <>{group.name}</>;
}
